// @ts-nocheck

import pkg from '../../package.json';
import Client from '../client';
import config from '../config/app.config';
import { getLang } from '../i18n/l10n';
import { RuntimeActionTypes } from '../types/actions/runtime';
import { getCustomHeaders } from '../utils';

import apiActionCreators from './api';

const { makeApiCall } = apiActionCreators;
const { keepaliveUrl } = config;

const refreshKeepAliveOk = ({ response }) => ({
  type: RuntimeActionTypes.REFRESH_KEEPALIVE_OK,
  payload: {
    response,
  },
});

const refreshKeepAliveKo = ({ error }) => ({
  type: RuntimeActionTypes.REFRESH_KEEPALIVE_KO,
  payload: {
    error,
  },
});

const refreshKeepAlive = () => ({
  type: RuntimeActionTypes.REFRESH_KEEPALIVE,
});

export const setLicence = (licence) => ({
  type: RuntimeActionTypes.SET_LICENCE,
  payload: {
    licence,
  },
});

// Init param - https://redmine.winamax.fr/issues/87944
const doRefreshKeepAlive = (init) => (dispatch, getState) => {
  dispatch(refreshKeepAlive());
  let url = `${keepaliveUrl[getLang()]}?d=1&v=${pkg.version}`;

  if (init) {
    url += `&init=1`;
  }

  const { user } = getState();
  const { token: jwt } = user?.jwt ?? {};
  const { sessionId, cc } = user ?? {};

  const method = 'get';
  const credentials = 'same-origin';
  const options = {
    url,
    method,
    credentials,
    headers: getCustomHeaders({ jwt, sessionId, cc, tracker: Client.tracker }),
  };

  const hooks = {
    success: (response) => {
      dispatch(refreshKeepAliveOk({ response }));
    },
    failure: (error) => {
      dispatch(refreshKeepAliveKo({ error }));
    },
  };
  dispatch(makeApiCall({ options, hooks }));
};

export const setWebSocketIsConnected = (isConnected) => ({
  type: RuntimeActionTypes.SET_WEBSOCKET_IS_CONNECTED,
  payload: {
    isConnected,
  },
});

export const setOverrideSettings = (overrideSettings) => ({
  type: RuntimeActionTypes.SET_OVERRIDE_SETTINGS,
  payload: {
    overrideSettings,
  },
});

export default {
  doRefreshKeepAlive,
};
